import { InputText } from "primereact/inputtext";
import { Message } from 'primereact/message';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Loader from "react-js-loader";
import { Link, useNavigate } from 'react-router-dom';
import { BadgeStatus, getEndpointUrl, getTimestamp } from '../../Utils/Common';
import { AiOutlinePlus } from "react-icons/ai";
import InfiniteScroll from 'react-infinite-scroll-component';
import CreateUser from "./CreateUser";
import UpdateUser from "./UpdateUser";
import DeleteUser from "./DeleteUser";
import { FaTrashAlt } from 'react-icons/fa';
import 'moment-timezone';
import Moment from 'react-moment';

const ListUsers = ({ props }) => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [options] = useState(
        JSON.parse(localStorage.getItem('options')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [isLoading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const inputRef = useRef();
    const timeout = useRef();
    const [searchQuery, setSearchQuery] = useState('');

    const [modalCreate, setModalCreate] = useState(false);

    const [selectedData, setSelectedData] = useState([]);

    const [showUpdate, setShowUpdate] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState(false);


    const fetchData = async () => {
        setLoading(true);
        try {

            const response = await fetch(getEndpointUrl() + `/users?page=${page}&per_page=${5}&query=${searchQuery}&v=${getTimestamp()}`, {
                headers: new Headers({
                    Authorization: `Bearer ${accesToken}`,
                    // pragma: 'no-cache',
                })
            });
            const data = await response.json();
            if (data.status === 'ok') {
                setItems([...new Set([...items, ...data.results.data])]);

                setPage(prevPage => prevPage + 1);

                if (items.length >= data.results.total)
                    setHasMore(false);
            }


        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        //        fetchData();
    }, [page]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!searchQuery.trim()) {
            fetchData()
            return
        }

        timeout.current = setTimeout(() => {
            fetchData();
        }, 600);
    }, [searchQuery]);

    const onSearchQuery = (e) => {
        setLoading(true);
        setHasMore(false);
        setPage(0);
        setItems([]);
        setSearchQuery(e.target.value);
    }

    const onCallback = useCallback((e) => {
        setLoading(true);
        setHasMore(false);
        setPage(0);
        setItems([]);
        fetchData();
    }, []);


    return (
        <>
            <Container>
                <Row className="mb-3">
                    <Col>
                        <Link to={'#'} title="Input Pengguna" onClick={(e) => setModalCreate(true)} className="btn btn-success"><AiOutlinePlus className="me-2" /> Input Pengguna</Link>
                        <CreateUser onCallback={(e) => onCallback(e)} show={modalCreate} close={(e) => setModalCreate(false)} />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div className="p-input-icon-left" style={{ display: 'block' }}>
                            <i className="pi pi-search" />
                            <InputText placeholder="Pencarian...[enter]" size={`small`} ref={inputRef} onChange={onSearchQuery} style={{ minWidth: '100%' }} />
                        </div>
                    </Col>
                </Row>
            </Container>
            <InfiniteScroll
                dataLength={items.length}
                next={fetchData}
                hasMore={hasMore}
                style={{ padding: '0px', margin: '0px' }}>
                {items.length > 0 ? items.map(value => (
                    <Container>
                        <Row>
                            <Col>
                                <div className="border rounded-3 px-3 py-3 mb-3">
                                    <div className="d-flex justify-content-between border-bottom">
                                        <div>
                                            <BadgeStatus status={value.status} />
                                        </div>
                                        <div className="ms-auto mb-2">

                                            <SplitButton size="small" label="Edit" icon="pi pi-pencil"
                                                disabled={value.id == 1 || value.id == userLogin.id}
                                                onClick={(e) => {
                                                    setShowUpdate(true);
                                                    setSelectedData(value);
                                                }}
                                                model={[
                                                    {
                                                        label: 'Hapus',
                                                        icon: 'pi pi-trash',
                                                        disabled: value.id == 1 || value.id == userLogin.id,
                                                        command: () => {
                                                            setSelectedData(value);
                                                            setConfirmDialog(true);
                                                        }
                                                    }
                                                ]} severity="secondary" text />
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted" style={{ fontSize: '12px' }}>NAMA PENGGUNA</small><br />
                                        <span className="fw-bold">{value.name}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>USERNAME</small><br />
                                        <span className="fw-medium">{value.username}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>HAK AKSES</small><br />
                                        <span className="fw-medium"><BadgeStatus status={value.role} /></span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>EMAIL</small><br />
                                        <span className="fw-medium">{value.email}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>NO HANDPHONE</small><br />
                                        <span className="fw-medium">{value.phone}</span><br />
                                        <small className="text-muted" style={{ fontSize: '12px' }}>TGL REGISTER</small><br />
                                        <span className="fw-normal fst-italic"> <Moment format="DD/MM/YYYY - HH:mm A">{value.createdAt}</Moment></span><br />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )) : !isLoading &&
                <Row>
                    <Col>
                        <Message severity="warn" text="Ups, Data pelanggan tidak tersedia!" style={{ display: 'block' }} />
                    </Col>
                </Row>
                }
            </InfiniteScroll>
            <UpdateUser row={selectedData} onCallback={(e) => onCallback(e)} show={showUpdate} close={() => setShowUpdate(false)} />
            <DeleteUser row={selectedData} onCallback={(e) => onCallback(e)} show={confirmDialog} close={() => setConfirmDialog(false)} />

            <Container>
                {isLoading &&
                    <Row>
                        <Col className="d-flex justify-content-center mt-3">
                            <Loader type="bubble-scale" bgColor={"#5772b8"} size={100} />
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default ListUsers;